import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=0c2ac304&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=js"
export * from "./Protocol.vue?vue&type=script&lang=js"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=0c2ac304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ac304",
  null
  
)

export default component.exports